import { gql } from '@apollo/client'

export const PAYMENT_CONFIRMATION_REFERENCE_QUERY = gql`
  query PaymentConfirmationReference($hash: String!) {
    bookingDetailVoucher(hash: $hash) {
      basicDetails {
        displayReservationNumber
      }
    }
  }
`
